import { HttpClient ,HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { of} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalFilterService {
  private filters: any = {
    queryParams: {},
    requestParams: {},
  };

  constructor(private http: HttpClient) {}

  private widgetId: string | null = null;

  private filterSubject = new Subject<any>();
  filter$ = this.filterSubject.asObservable();

  private currentSelectedFilter = new Subject<any>();
  currentFilter$ = this.currentSelectedFilter.asObservable();

  private selectedFilters: { [key: string]: string | null } = {};
  activeFilter!: any;

  // 🔹 NEW: last export/table payload publisher
  private exportPayloadSubject = new BehaviorSubject<any>(null);
  exportPayload$ = this.exportPayloadSubject.asObservable();
  setExportPayload(payload: any) {
    this.exportPayloadSubject.next(payload);
  }
  getLatestExportPayload() {
    return this.exportPayloadSubject.getValue();
  }

  isSelected(key: string, value: string): boolean {
    return this.selectedFilters[key] === value;
  }

  updateFilterSelection(
    key: string,
    values: any[],
    isQueryParam = false,
    widgetId?: string,
    emit: boolean = true
  ): void {
    this.selectedFilters[key] = values?.[0] || null;

    if (isQueryParam) {
      this.filters.queryParams[key] = values;
    } else {
      this.filters.requestParams[key] = values;
    }

    this.widgetId = widgetId || null;

    if (emit) {
      this.filterSubject.next({
        ...this.filters,
        widgetId: this.widgetId,
      });
      this.currentSelectedFilter.next({ key });
    }
  }

  resetFilterSelection(key: string, isQueryParam = false): void {
    delete this.selectedFilters[key];
    if (isQueryParam) {
      delete this.filters.queryParams[key];
    } else {
      delete this.filters.requestParams[key];
    }
    this.filterSubject.next({
      ...this.filters,
      widgetId: this.widgetId,
    });
  }

  deleteKey(key: string, isQueryParam = false): void {
    delete this.selectedFilters[key];
    if (isQueryParam) {
      delete this.filters.queryParams[key];
    } else {
      delete this.filters.requestParams[key];
    }
  }

  getCurrentFilters(): any {
    return this.filters;
  }

  updateAllFilters(newFilters: any): void {
    this.filters = newFilters;
    this.filterSubject.next(this.filters);
    this.currentSelectedFilter.next({});
  }

  clearAllFilters() {
    this.filterSubject.next({ queryParams: {}, requestParams: {}, widgetId: null });
    this.selectedFilters = {};
    this.currentSelectedFilter.next('');
  }

  initialTrigger() {
    this.filterSubject.next({ queryParams: {}, requestParams: {}, widgetId: null });
  }

//  downloadExcel(apiUrl: string, filterPayload: any, token?: string): Observable<Blob> {
//   // Set Authorization header with Bearer token
//   const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
//   console.log("filterPayload in service:", filterPayload);

//   // Send POST request with Bearer token in headers and response type set to 'blob'
//   return this.http.post(apiUrl, filterPayload, { headers, responseType: 'blob' });
// }
downloadExcel(apiUrl: string, filterPayload: any, token?: string): Observable<Blob> {
  // ✅ If partNumbers is missing or empty, don't call the API
  if (
    !filterPayload ||
    !Array.isArray(filterPayload.partNumbers) ||
    filterPayload.partNumbers.length === 0
  ) {
    console.warn('Skipping Excel download: no part numbers in payload');
    // Still return an Observable<Blob> so the caller code doesn't break
    return of(new Blob());
  }

  // Set Authorization header with Bearer token
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  // Send POST request with Bearer token in headers and response type set to 'blob'
  return this.http.post(apiUrl, filterPayload, {
    headers,
    responseType: 'blob'
  });
}

}
